export enum FormUrl {
	BUILD_PERMIT = '/forms/map-permit-application-edit',
	DESIGN_APPROVAL = '/forms/design-approval',
	ARCHITECTURE_B = '/forms/architecture-design-classB-form',
	ARCHITECTURE_C = '/forms/architecture-design-classc-form',
	STRUCTURE_B = '/forms/structure-design-classB-form',
	STRUCTURE_C = '/forms/structure-design-classc-form',
	ANUSUCHI_GA = '/forms/anusuchiga-view',
	MAP_TECH = '/forms/map-technical-description-view',
	MAP_CHECK_REPORT = '/forms/user/forms/map-check-report-view',
	RAJASOW_VOUCHER = '/forms/rajaswo-voucher',
	NOTICE_PAYMENT_APPLICATION = '/forms/notice-payment-application-view',
	GHAR_NAKSA_SURJAMIN = '/forms/gharnaksha-surjamin-muchulka-view',
	PURANO_GHAR_NIRMAN_TIPPANI = '/forms/purano-ghar-nirman-tippani',
	SANSODHAN_TIPPANI = '/forms/sansodhan-tippani',
	SAMSODHAN_BILL_VUKTANI = '/forms/samsodhan-bill-vuktani',
	SANSODHAN_SUPER_STRUCTURE = '/forms/superstructureko-tippaniadesh',
	DOSRO_CHARAN_BILL_VUKTANI = '/forms/dosrocharan-bill-vuktani',
	SANSODHAN_BIBARAN_PAHILO = '/forms/sansodhan-bibaran-pahilo',
	PAHILO_CHARAN_BILL_VUKTANI = '/forms/pahilo-charan-bill-vuktani',
	NOTE_ORDER_PLINTH_LEVEL = '/forms/noteorder-pilength-level-view',
	BUILDING_FINISH_CERTIFICATE = '/forms/building-finish-certificate-view',
	BUILDING_BUILD_CERTIFICATE = '/forms/building-build-certificate-view',
	PURANO_GHAR_SAMPANNA_PRAMANPATRA = '/forms/purano-ghar-sampanna-pramanpatra',
	NAKSA_FILE_PATHAYEKO_BARE = '/forms/naksa-file-pathayeko-bare',
	LAYOUT_GARI_PRATIBEDAN_REQUEST = '/forms/layout-gari-pratibedan-request',
	LAYOUT_GARI_PRATIBEDAN_IJAJAT = '/forms/layout-gari-pratibedan-ijajat',
	NAYA_RECORD_PATHAYEKO_BARE = '/forms/naya-record-sambandhama',
	DHARAUTI_FIRTA_TIPPANI_AADESH = '/forms/dharauti-firta-tippani-aadesh',
	NIRMAN_PRAMANPATRA_DHARAUTI = '/forms/nirman-pramanpatra-dharauti',
	DHARAUTI_RAKAM_PHIRTA = '/forms/dharauti-rakam-phirta-bare',
	NAPI_NIRIKSHYAN_PRATIBEDAN = '/forms/napi-nirikshyan-pratibedan',
	DOSRO_CHARAN_SAMPANNAKO_PRABIDHIKKO_PRATIBEDAN = '/forms/dosro-charan-sampannako-prabidhikko-pratibedan',
	PRATHAM_CHARAN_ANUMATI_REQUEST = '/forms/pratham-charan-anumati-request',
	NAKSA_PASS_CERTIFICATE = '/forms/naksa-pass-certificate',
	PRABIDHIK_PRATIBEDAN = '/forms/prabhidik-pratibedhan-pesh-view',
	NO_OBJECTION_SHEET = '/forms/no-objection-sheet',
	ALLOWANCE_PAPER = '/forms/allowance-paper-view',
	SUPERSTRUCTURE_NOTE_ORDER = '/forms/superStructure-noteOrder-view',
	CERTIFICATE_PRATIBEDAN_SAMBANDHAMA = '/forms/certificate-pratibedan-sambandhama',
	CERTIFICATE_PRATIBEDAN_PESH_BARE = '/forms/certificate-pratibedan-pesh-bare',
	SANSODHAN_SUPERSTRUCTURE_IJAJAT = '/forms/sansodhan-super-structure-ijjaat',
	PLINTH_LEVEL_TECH_APP = '/forms/plinthLevel-techapplication-view',
	SUPERSTRUCTURE_KO_NIRMAN_KARYA = '/forms/superstructureko-nirmaan-karya',
	CERTIFICATE_INSTRUCTION_VIEW = '/forms/certificate-instruction-view',
	SANSODHANKO_TIPPANI_ADES = '/forms/sansodhanko-tippani-adesh',
	SANSODHAN_SUPER_TIPPANI_ADESH = '/forms/sansodhansuper-tippani-adesh',
	NOTICE_15_DAYS = '/forms/notice-period-for-15-days-view',
	SUCHANA_TAS_GARI_MUCHULKA_PATHAIDINA = '/forms/suchana-tas-gari-muchulka-pathaidina',
}

export enum FormUrlFull {
	BUILD_PERMIT = '/user/forms/map-permit-application-edit',
	DESIGN_APPROVAL = '/user/forms/design-approval',
	ARCHITECTURE_B = '/user/forms/architecture-design-classB-form',
	ARCHITECTURE_C = '/user/forms/architecture-design-classc-form',
	STRUCTURE_B = '/user/forms/structure-design-classB-form',
	STRUCTURE_C = '/user/forms/structure-design-classc-form',
	ANUSUCHI_GA = '/user/forms/anusuchiga-view',
	MAP_TECH = '/user/forms/map-technical-description-view',
	MAP_CHECK_REPORT = '/user/forms/map-check-report-view',
	RAJASOW_VOUCHER = '/user/forms/rajaswo-voucher',
	NOTICE_PAYMENT_APPLICATION = '/user/forms/notice-payment-application-view',
	GHAR_NAKSA_SURJAMIN = '/user/forms/gharnaksha-surjamin-muchulka-view',
	PURANO_GHAR_NIRMAN_TIPPANI = '/user/forms/purano-ghar-nirman-tippani',
	SANSODHAN_TIPPANI = '/user/forms/sansodhan-tippani',
	SAMSODHAN_BILL_VUKTANI = '/user/forms/samsodhan-bill-vuktani',
	SANSODHAN_SUPER_STRUCTURE = '/user/forms/superstructureko-tippaniadesh',
	DOSRO_CHARAN_BILL_VUKTANI = '/user/forms/dosrocharan-bill-vuktani',
	SANSODHAN_BIBARAN_PAHILO = '/user/forms/sansodhan-bibaran-pahilo',
	PAHILO_CHARAN_BILL_VUKTANI = '/user/forms/pahilo-charan-bill-vuktani',
	NOTE_ORDER_PLINTH_LEVEL = '/user/forms/noteorder-pilength-level-view',
	BUILDING_FINISH_CERTIFICATE = '/user/forms/building-finish-certificate-view',
	BUILDING_BUILD_CERTIFICATE = '/user/forms/building-build-certificate-view',
	PURANO_GHAR_SAMPANNA_PRAMANPATRA = '/user/forms/purano-ghar-sampanna-pramanpatra',
	NAKSA_FILE_PATHAYEKO_BARE = '/user/forms/naksa-file-pathayeko-bare',
	LAYOUT_GARI_PRATIBEDAN_REQUEST = '/user/forms/layout-gari-pratibedan-request',
	LAYOUT_GARI_PRATIBEDAN_IJAJAT = '/user/forms/layout-gari-pratibedan-ijajat',
	NAYA_RECORD_PATHAYEKO_BARE = '/user/forms/naya-record-sambandhama',
	NIRMAN_PRAMANPATRA_DHARAUTI = '/user/forms/nirman-pramanpatra-dharauti',
	DHARAUTI_RAKAM_PHIRTA = '/user/forms/dharauti-rakam-phirta-bare',
	DHARAUTI_RAKAM_PHIRTA_TIPPANI = '/user/forms/dharauti-rakam-phirta-tippani',
	NAPI_NIRIKSHYAN_PRATIBEDAN = '/user/forms/napi-nirikshyan-pratibedan',
	DOSRO_CHARAN_SAMPANNAKO_PRABIDHIKKO_PRATIBEDAN = '/user/forms/dosro-charan-sampannako-prabidhikko-pratibedan',
	PRATHAM_CHARAN_ANUMATI_REQUEST = '/user/forms/pratham-charan-anumati-request',
	NAKSA_PASS_CERTIFICATE = '/user/forms/naksa-pass-certificate',
	PRABIDHIK_PRATIBEDAN = '/user/forms/prabhidik-pratibedhan-pesh-view',
	NO_OBJECTION_SHEET = '/user/forms/no-objection-sheet',
	ALLOWANCE_PAPER = '/user/forms/allowance-paper-view',
	SUPERSTRUCTURE_NOTE_ORDER = '/user/forms/superStructure-noteOrder-view',
	CERTIFICATE_PRATIBEDAN_SAMBANDHAMA = '/user/forms/certificate-pratibedan-sambandhama',
	CERTIFICATE_PRATIBEDAN_PESH_BARE = '/user/forms/certificate-pratibedan-pesh-bare',
	SANSODHAN_SUPERSTRUCTURE_IJAJAT = '/user/forms/sansodhan-super-structure-ijjaat',
	PLINTH_LEVEL_TECH_APP = '/user/forms/plinthLevel-techapplication-view',
	SUPERSTRUCTURE_KO_NIRMAN_KARYA = '/user/forms/superstructureko-nirmaan-karya',
	CERTIFICATE_INSTRUCTION_VIEW = '/user/forms/certificate-instruction-view',
	SANSODHANKO_TIPPANI_ADES = '/user/forms/sansodhanko-tippani-adesh',
	SANSODHAN_SUPER_TIPPANI_ADESH = '/user/forms/sansodhansuper-tippani-adesh',
	NOTICE_15_DAYS = '/user/forms/notice-period-for-15-days-view',
	SUCHANA_TAS_GARI_MUCHULKA_PATHAIDINA = '/user/forms/suchana-tas-gari-muchulka-pathaidina',
}
